import type { ReactNode } from 'react';

/**
 * A short, bounded value: a position code, a squad status, an age category.
 * Positions use the condensed cut because they are codes read at a glance, and
 * are tinted by unit so a defender and a forward are distinguishable without
 * reading the letters.
 */
const units = {
  gk: 'bg-load-rest/12 text-load-rest',
  defence: 'bg-load-low/12 text-load-low',
  midfield: 'bg-load-moderate/14 text-load-moderate',
  attack: 'bg-load-high/12 text-load-high',
  neutral: 'bg-surface-sunken text-ink-muted',
} as const;

export function PositionChip({
  code,
  unit = 'neutral',
}: {
  code: string;
  unit?: keyof typeof units;
}) {
  return (
    <span
      className={`tabular inline-flex min-w-9 items-center justify-center rounded-[3px] px-1.5 py-0.5 font-condensed text-meta font-semibold ${units[unit]}`}
    >
      {code}
    </span>
  );
}

export function Chip({ children, muted = false }: { children: ReactNode; muted?: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded-[3px] border px-1.5 py-0.5 text-meta ${
        muted ? 'border-line text-ink-faint' : 'border-line-strong text-ink-muted'
      }`}
    >
      {children}
    </span>
  );
}
